import axios, { AxiosResponse } from 'axios';

import { monolithApi } from '@/utils/api';

// monolithApi reads the CSRF token once per page load. When the session changed since, the server
// rejects the token and sends a fresh one, so the sign-in is retried once with it.
const postSignIn = async <T>(data: unknown): Promise<AxiosResponse<T>> => {
  try {
    return await monolithApi.post<T>('/users/sign_in.json', data);
  } catch (error) {
    const csrfToken = axios.isAxiosError(error) ? error.response?.data?.csrfToken : undefined;
    if (!csrfToken) {
      throw error;
    }

    return monolithApi.post<T>('/users/sign_in.json', data, { headers: { 'X-CSRF-TOKEN': csrfToken } });
  }
};

export default postSignIn;
